require('@/polyfills/customevent')
;(function () {
  var TIMEOUT = 900

  var timer
  var isResizing = false
  var resizeStart = new CustomEvent('resizestart')
  var resizeEnd = new CustomEvent('resizeend')

  window.addEventListener('resize', function () {
    clearTimeout(timer)

    if (!isResizing) {
      isResizing = true
      window.dispatchEvent(resizeStart)
    }

    timer = setTimeout(function () {
      window.dispatchEvent(resizeEnd)
      isResizing = false
    }, TIMEOUT)
  })
})()
